import React from 'react';
import Status from './Status';
import InvoiceList from './InvoiceList';

import { Card} from 'react-bootstrap';
import WareHouseSummary from './WareHouseSummary';
import InvoiceSummaryHistory from './InvoiceSummaryHistory';
import BrakesInvoiceUploader from './BrakesInvoiceUploader';



class Dashboard extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.fetchWarehouseDashboard('Foulger');
  }


  render() {
    const { warehousedashboard } = this.props;

    if( warehousedashboard.isFetching ){
      return (
        <Card className="dashboard"   header="Dashboard">
         <div className="loader">Loading...</div>
        </Card>
      )
    }else{
      return(
        <Card className="dashboard"   header="Dashboard">
          <Card.Title>Dashboard</Card.Title>
          <Status key={warehousedashboard.lastUpdated} warehousedashboard={this.props.warehousedashboard} syncWarehouses={this.props.syncWarehouses} reconcileMatches={this.props.reconcileMatches}/>
          <InvoiceList invoiceList={warehousedashboard.dashboard.missingWarehouseInvoiceList} name="Invoices to update with Warehouse" />
          <WareHouseSummary {...this.props} warehouse="FDC"  />
          <BrakesInvoiceUploader />      
          <InvoiceSummaryHistory warehouse="FDC" />
        </Card>
      )
    }
  }
}



//export default connect(mapStateToProps, mapDispachToProps)(Dashboard)

export default Dashboard;
